export default "__VITE_ASSET__BayMgJZg__"